






















import { Component, Vue } from "vue-property-decorator";
import { Data, Prop } from "@rocketbase/vue-extra-decorators";

@Component
export default class Login extends Vue {
  @Data({ default: "" })
  private name!: string;

  @Data({ default: "" })
  private password!: string;

  @Data({ default: "" })
  private message!: string;

  @Data({ default: false })
  private snackbar!: boolean;

  loginByAuth(): void {
    this.$auth
      .login(this.name, this.password)
      .then(r => {
        this.message = "Login erfolgreich";
        this.snackbar = true;
        this.$router.replace("/");
      })
      .catch(e => {
        this.message = "Ups - da ist etwas schief gelaufen";
        this.snackbar = true;
      });
  }
}
